/*
 * @Author: pengyong
 * @Date: 2020-11-11 22:20:56
 * @LastEditors: pengyong
 * @LastEditTime: 2020-12-03 21:30:38
 * @Description: 个人中心接口定义
 * @FilePath: /exhibit/src/api/user.js
 */
import axios from "@/utils/axios.js";
import { BASE_URL, EXHIBITOR_URL, LOGIN_URL } from "./config";

// 获取用户信息
export function getUserInfo(params) {
    return axios.$get(`${BASE_URL}/account/api/v1/profile`, params);
}
// 修改基本资料
export function setUserInfo(params) {
    return axios.$patch(`${BASE_URL}/account/api/v1/profile`, params);
}
// 修改密码
export function changePassword(params) {
    return axios.$post(`${LOGIN_URL}/profile/change_password`, params);
}
// 获取我的名片
export function getMyCard(params) {
    return axios.$get(`${EXHIBITOR_URL}/v1/purchaser/business_card/my_card`, params);
}
// 设置我的名片
export function setMyCard({ id, params }) {
    return axios.$patch(`${BASE_URL}/exhibition/api/v1/purchaser/business_card/${id}`, params);
}
// 名片夹
export function getCardList(params) {
    return axios.$get(`${BASE_URL}/exhibition/api/v1/purchaser/business_card/card_holder`, params);
}
// 删除名片
export function deleteCard(id, params) {
    return axios.$delete(`${BASE_URL}/exhibition/api/v2/purchaser/business_card/cancel_switch/${id}`, params);
}
// 展品收藏列表
export function getMarkProduct(params) {
    return axios.$get(`${BASE_URL}/exhibition/api/v1/purchaser/exh_product/mark`, params);
}
// 取消展品收藏
export function deleteMarkProduct(id, params) {
    return axios.$delete(`${BASE_URL}/exhibition/api/v2/purchaser/exh_product/unmark/${id}`, params);
}
// 展商收藏列表
export function getMarkExhibitor(params) {
    return axios.$get(`${BASE_URL}/exhibition/api/v1/purchaser/exh_company/mark`, params);
}
// 取消展商收藏
export function deleteMarkExhibitor(id, params) {
    return axios.$delete(`${BASE_URL}/exhibition/api/v2/purchaser/exh_company/unmark/${id}`, params);
}
// 视频收藏列表
export function getMarkVideo(params) {
    return axios.$get(`${BASE_URL}/exhibition/api/v1/purchaser/resource/mark`, params);
}
// 取消视频收藏
export function deleteMarkVideo(id, params) {
    return axios.$delete(`${BASE_URL}/exhibition/api/v2/purchaser/resource/unmark/${id}`, params);
}
// 文件收藏列表
export function getMarkDoc(params) {
    return axios.$get(`${BASE_URL}/exhibition/api/v1/purchaser/com_doc/mark`, params);
}
// 取消文件收藏
export function deleteMarkDoc(params) {
    return axios.$delete(`${BASE_URL}/exhibition/api/v2/purchaser/com_doc/unmark`, params);
}



// WEBPACK FOOTER //
// ./src/api/user.js